// extracted by mini-css-extract-plugin
export default {"form":"Checkout_form__082RA","control":"Checkout_control__HHcH0","actions":"Checkout_actions__+ahNw","submit":"Checkout_submit__27F+l","invalid":"Checkout_invalid__ZY95c"};